export enum StatusEnvelope {
  Finished = 'finalizado',
  Process = 'emProcesso',
  Expired = 'expirado',
  Canceled = 'cancelado',
}
